import React from 'react';
import { useSelector } from 'react-redux';

// Own constants/actions/components
import ButtonFloat from 'components/button-float';
import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import DetailExperienceReviveContainer from 'containers/detail-experience-inspire';
import { items } from 'services/selectors/shopping-cart';

const DetailExpRevivePage = () => {
  const itemsCart = useSelector(items);

  return (
    <div>
      <ButtonFloat number={itemsCart.length} />
      <HeaderContainer />
      <DetailExperienceReviveContainer />
      <FooterContainer />
    </div>
  );
};

export default DetailExpRevivePage;
